/**
 * ComposeVisualPopup - Now uses the enhanced ContextAttachPopup
 * Kept for backward compatibility
 */

import { ContextAttachPopup } from './ContextAttachPopup';

export const ComposeVisualPopup = ContextAttachPopup;
